// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__hPX_V","form":"styles_form__1qGdr"};